import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { ActionReducerMap, Store} from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { IMobileApp, mobileAppReducer } from './mobile.app.era';
import { takeUntil } from 'rxjs/operators';

export interface MobileAppState {
  app: IMobileApp
  router: RouterReducerState
}

export const mobileStoreRootReducer: ActionReducerMap<MobileAppState, any> = {
  app: mobileAppReducer,
  router: routerReducer
}

export interface MobileStoreWithDestroy { store: Store, $destroy: Subject<any> }

export const mobileSubCallback = <T> (destroySubject: Subject<boolean>, obs: Observable<T>, callback: (val: T) => void) => 
obs.pipe(takeUntil(destroySubject)).subscribe((val: T) => callback(val))

export const mobileSubTilDestroy = <C extends MobileStoreWithDestroy, T extends C[K], K extends keyof C>
  (that: C, obs: Observable<T>, prop: K, destroySubject: Subject<boolean> = null) => obs.pipe(takeUntil(destroySubject || that.$destroy)).subscribe(val =>
    that[prop] = val
  )


